import { useFormikContext } from 'formik';
import { Box, Card, Typography, useTheme } from '@mui/material';
import { Field } from '~/components/common/Formik2';
import { ANNOUNCEMENT_TYPE } from 'bs-unified-ui';
import { MESSAGE_WORD_LIMITS } from '~/constants';
import { useMemo } from 'react';
import { countWords } from '~/utils/textProcessing';
import ImageUploadField from './ImageUploadField';
import { useAnnouncementDetailContext } from '../AnnouncementDetailContext';

const MessageSection = () => {
  const theme = useTheme();
  const { values } = useFormikContext<any>();
  const { isArchived } = useAnnouncementDetailContext();

  const isRichPopup = values.type === ANNOUNCEMENT_TYPE.RICH_POP_UP;

  // Calculate word count and max words based on type
  const { wordCount, maxWords } = useMemo(() => {
    const words = countWords(values.message_description);

    // Get max words from constant
    const max =
      MESSAGE_WORD_LIMITS[values.type as keyof typeof MESSAGE_WORD_LIMITS] ||
      100;

    return { wordCount: words, maxWords: max };
  }, [values.message_description, values.type]);

  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        pointerEvents: isArchived ? 'none' : 'auto',
        color: theme.foreground.black,
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: 18,
        }}
      >
        Message
      </Typography>
      {values.type !== ANNOUNCEMENT_TYPE.GLOBAL_BANNER && (
        <Field.Input name='message_title' label='Title' fullWidth />
      )}
      <Box
        sx={{
          '.ql-editor': {
            padding: '12px 15px !important',
          },
        }}
      >
        <Field.TextEditor
          name='message_description'
          label='Description'
          // disableFirstChangeCondition
        />
        <Typography
          sx={{
            mt: 0.5,
            color: wordCount > maxWords ? '#F24822' : 'rgba(51, 54, 61, 0.40)',
          }}
          variant='fs14'
        >
          Maximum {maxWords} words
        </Typography>
      </Box>
      {isRichPopup && <ImageUploadField name='image' label='Upload image' />}
    </Card>
  );
};

export default MessageSection;
